import { inject, Injectable } from '@angular/core';
import { ApiService, ErrorMapType } from './api.service';
import { WindowProvider } from './window.provider.js';

@Injectable({
  providedIn: 'root',
})
export class CoinflowService extends ApiService {
  private readonly _window = inject(WindowProvider);

  readonly ErrorMap: ErrorMapType = {
    LOCATION_REQUIRED: { swallowError: false },
    PURCHASE_LIMIT_REACHED: { swallowError: false },
    MODE_RESTRICTED: { swallowError: false },
    CASINO_SETTING_DISABLED: { swallowError: false },
  };

  /**
   * `purpose` discriminates the server's money-tier location gate: `purchase`
   * mints are gated, `bank_linking` (redemption withdrawals) stays ungated.
   */
  async createSessionToken(purpose: 'purchase' | 'bank_linking') {
    return (
      await this.get<{ sessionKey: string }>('/coinflow/session-key', {
        params: { purpose },
      })
    ).sessionKey;
  }

  get deviceId() {
    return (this._window as unknown as { coinflowDeviceId: string })
      .coinflowDeviceId;
  }
}
